import { Search } from "lucide-react";

import { BarChartCard } from "./BarChartCard";
import { formatCount } from "./chartPalette";
import { DonutChartCard } from "./DonutChartCard";
import { ChartsGrid, InsightsPanel, StatsRow } from "./InsightsLayout";
import { StatCard } from "./StatCard";
import { TrendChartCard } from "./TrendChartCard";

export const InvestigationsInsights = ({ insights, isLoading }) => {
  return (
    <InsightsPanel>
      <StatsRow>
        <StatCard label="Total Investigations" icon={Search} isLoading={isLoading}
          value={formatCount(insights?.totalInvestigations)} />
      </StatsRow>
      <ChartsGrid>
        <DonutChartCard title="By Type" data={insights?.byType} isLoading={isLoading} />
        <BarChartCard title="By Doctor" data={insights?.byDoctor} isLoading={isLoading} />
        <TrendChartCard title="Investigations Over Time" data={insights?.trendByDay} isLoading={isLoading} />
      </ChartsGrid>
    </InsightsPanel>
  );
};
